import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HeroVenue from "../components/Hero_venue";
import heroImage from "../assets/RsjcLogo.svg";
import Canonical from "../components/canonical";

export function Links() {
  return (
    <React.Fragment>
      <Canonical />
      <Navbar linkName="Home" />
      <HeroVenue imageSrc={heroImage} heroAreaName="links" />
      <div className=" bg-[#01184D] text-white w-full text-center flex flex-col items-center justify-center ">
        <div className="my-8">
          <h1 className="uppercase md:text-4xl text-xl sm:text-2xl pb-8">
            Links
          </h1>
          <p className="mx-6 md:text-xl sm:text-lg text-sm pb-4">
            Check out the links below for useful resources, including Rising Sun
            Judo Club's Social Media and Sussex County Judo's Website
          </p>
        </div>

        <div className="bg-[#075AAA] w-full mx-auto text-center flex flex-col items-center justify-center pb-2">
          <div className="max-w-[800px] items-start justify-center gap-x-4 pb-4 ">
            <h1 className="uppercase my-8 md:text-4xl text-xl sm:text-2xl ">
              Facebook
            </h1>
            <p className="mx-6 md:text-xl sm:text-lg text-sm my-6">
              Rising Sun Judo Club on Facebook
            </p>
            <button className="px-4 py-2 bg-white text-[#075AAA] font-bold">
              {" "}
              <a href="https://www.facebook.com/rsjcWorthing - The Studio, Worthing Leisure Centre, Shaftesbury Avenue, Worthing BN12 4ET">
                Click Here
              </a>
            </button>
          </div>
        </div>
        <div className="bg-white text-[#01184D] w-full mx-auto text-center flex flex-col items-center justify-center">
          <div className="max-w-[800px] items-start justify-center gap-x-4 pb-4 ">
            <h1 className="uppercase my-8 md:text-4xl text-xl sm:text-2xl ">
              Sussex County Judo
            </h1>
            <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
              The main website for Sussex County Judo
            </p>
            <button className="px-4 py-2 border border-[#01184D] bg-white text-[#01184D] font-bold">
              {" "}
              <a href="https://www.sussexjudo.org/home">Click Here</a>
            </button>
          </div>
        </div>
        <div className="text-white bg-[#C8102E] w-full mx-auto text-center flex flex-col items-center justify-center">
          <div className="max-w-[800px] items-start justify-center gap-x-4 pb-4 ">
            <h1 className="uppercase my-8 md:text-4xl text-xl sm:text-2xl ">
              The British Judo Association (BJA)
            </h1>
            <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
              The main website for The British Judo Association (BJA)
            </p>
            <button className="px-4 py-2 bg-white text-[#C8102E] font-bold">
              {" "}
              <a href="https://www.britishjudo.org.uk/">Click Here</a>
            </button>
          </div>
        </div>
      </div>
      <Footer year={new Date().getFullYear()} />
    </React.Fragment>
  );
}
